import { connect } from 'react-redux';
import { getFolderStream } from '../../redux/selectors';
var mapStateToProps = function (state, ownProps) {
    return getFolderStream(state, ownProps.deviationId, ownProps.submissionType, ownProps.groupId);
};
export default connect(mapStateToProps);
//# sourceMappingURL=FolderList.container.js.map